import request from '@/utils/request'

/**
 * 获取用户订单列表
 * @param {Object} params 查询参数
 * @param {String} params.personId 用户ID
 * @param {Number} params.page 页码
 * @param {Number} params.row 每页条数
 * @returns {Promise} 返回请求的Promise对象
 */
export function getOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryAdminStoreOrderCart',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}